// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { Link, useLocation, useHistory } from "react-router-dom";
import logo from "../../../../assets/images/hero.png";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import HeaderComponent from "../header/header";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import { aiDcapRegister, headers, accessToken,insertUserFeaturesByIdEndPoint } from '../../../../common/api-config'

/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */
const Register = (props) => {
    const options = [
        { value: 'USER', label: 'USER' },
        { value: 'ADMIN', label: 'ADMIN' },
        { value: 'BUSINESS_USER', label: 'BUSINESS_USER' },
        {
                value:"MANAGED_SERVICES",
                label:"MANAGED_SERVICES"
            },
            {
                value:"MANAGED_SERVICES_ADMIN",
                label:"MANAGED_SERVICES_ADMIN"
            },
            {
                value:"BUSINESS_API_USER",
                label:"BUSINESS_API_USER"
            }
    ]
    const adminOptions = [
        { value: 'ROLE_USER', label: 'USER' },
    ]
    const tenantNames = [
        //{ value: '1', label: 'JBS' },
        { value: '2', label: 'Mouritech' },
        { value: '3', label: 'Randomtrees' },
    ]
    
    const chepUserOptions = [
        { value: '1', label: 'CHEP_USER' },
        { value: '2', label: 'MIS_USER' },
        { value: '3', label: 'GEN_USER' },
        
    ]
    
    let history = useHistory();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('')
    const [contact, setContact] = useState('')
    const [role, selectRole] = useState('')
    const [roleValue, selectRoleDropdown] = useState(null);
    const [tenentValue, selectTenentDropdown] = useState(null);
    const [tenantName, selectTenantName] = useState('')
    const [tenentId, setTenantId] = useState('')
    const [loader, setLoader] = useState(false);
    const [chepRoleName, selectCHEPRole] = useState('');
    const [chepRoleValue, selectChepRoleDropdown] = useState(null);
    const [chepRoleId, setChepRoleId] = useState('');

    const handleChangeName = (e) => {
        setFirstName(e.target.value)
    }

    const handleChangeLastName = (e) => {
        setLastName(e.target.value);
    }

    const handleChangeEmail = (e) => {
        setEmail(e.target.value);
    }

    const handleChangeContact = (e) => {
        setContact(e.target.value);
    }

    const handleSelectRole = (e) => {
        selectRoleDropdown(e);
        selectRole(e.value);
    }

    const handleSelectTenant = (e) => {
        selectTenantName(e.label);
        selectTenentDropdown(e);
        if (e.label == 'JBS') {
            setTenantId('1')
        } else if (e.label == 'MOURITECH') {
            setTenantId('2')
        } else {
            setTenantId('3')
        }
    }
    
    
    const handleSelectCHEPRole = (e) => {
        selectCHEPRole(e.label);
        selectChepRoleDropdown(e);
        if (e.label == 'CHEP_USER') {
            setChepRoleId('1')
        } else if (e.label == 'MIS_USER') {
            setChepRoleId('2')
        } else {
            setChepRoleId('3')
        }
    }

    const signInUserSession = localStorage.getItem("signInUserSession");
    const user = signInUserSession && JSON.parse(signInUserSession);

    const dropDownSelectionView = () => {
        const customStyles = {
            menu: (provided, state) => ({
              ...provided,
              zIndex: 9999
            })
          };
          
        if (user && user.user_data.role == 'ADMIN') {
            return (
                <div style={{zIndex: 99999, position: "relative"}}>
                    <Select 
                    options={options}
                        styles={customStyles}
                        onChange={handleSelectRole}
                        value={roleValue}
                        placeholder="Select"
                        className="react-select-container zindex-20"
                        // isClearable={true}
                        theme={(theme) => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: "#161a1f",
                                primary: "#6b727d",
                                neutral0: "#222830",
                                neutral20: "#44474c",
                                neutral30: "#272c33",
                                neutral50: "#fff",
                                neutral80: "#9da7b5",
                            },
                        })}

                    />
                </div>
            )
        } else if (user && user.user.extension_role == 'ROLE_ADMIN') {
            return (
                <div>
                    <Select options={adminOptions}
                        onChange={handleSelectRole}
                        value={roleValue}
                        placeholder="Select"
                        className="react-select-container zindex-20"
                        // isClearable={true}
                        theme={(theme) => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: "#161a1f",
                                primary: "#6b727d",
                                neutral0: "#222830",
                                neutral20: "#44474c",
                                neutral30: "#272c33",
                                neutral50: "#fff",
                                neutral80: "#9da7b5",
                            },
                        })}

                    />
                </div>
            )
        }
    }

    const validation = () => {
        let valid = false
        if (firstName.length == 0) {
            valid = false
            toast.error(`First Name should not be empty.`, { position: toast.POSITION.TOP_CENTER });
        }
        if (lastName.length == 0) {
            toast.error(`Last Name should not be empty..`, { position: toast.POSITION.TOP_CENTER });
        }
        if (email.length == 0) {
            valid = false
            toast.error(`Email should not be empty.`, { position: toast.POSITION.TOP_CENTER });
        } else {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                valid = true
            } else {
                valid = false
                toast.error(`You have entered an invalid email address`, { position: toast.POSITION.TOP_CENTER });
            }
        }
        if (role == '' && valid) {
            valid = false
            toast.error(`Please select role`, { position: toast.POSITION.TOP_CENTER });
        }
        if (tenantName == '' && valid) {
            valid = false
            toast.error(`Please select tenant name`, { position: toast.POSITION.TOP_CENTER });
        }
        // if (chepRoleName == '' && valid) {
        //     valid = false
        //     toast.error(`Please select CHEP Role name`, { position: toast.POSITION.TOP_CENTER });
        // }
        if (valid == true) {
            register()
        }
    }
    const register = () => {
        setLoader(true);
        const registerObj = {
            "email": email,
            "first_name": firstName,
            "last_name": lastName,
            "role": role,
            "contact_no": contact,
            // "appName": "DCAP",
            "tenant_name": tenantName,
            "tenant_id":tenentId
        }
        const endpointURL = aiDcapRegister();
        let headers = accessToken();
        axios(endpointURL, { method: "POST", data: registerObj, headers }).then(async (data) => {
            setLoader(false)
            debugger;
            if (data.data.status === 400) {
                toast.error(`Something Went Wrong!`, { position: toast.POSITION.TOP_CENTER });
            } else if (data.data.status === 200) {
                toast.success(`success`, { position: toast.POSITION.TOP_CENTER });
                
                //check for Chep User call start
               // const endpointURL = aiDcapRegister(registerObj);
                if(chepRoleName === "CHEP_USER" || chepRoleName === "MIS_USER")
                {
                    const role = chepRoleName ==="CHEP_USER"?"ROLE_CHEP_USER":"ROLE_MGSERVICE_USER";
                    const mfeatures = ["Performance Metrics", "Document Management"];
                    const cfeatures =  ["Performance Metrics", "Document Management", "Order Management"];
                    const roleFeatures = chepRoleName ==="CHEP_USER"?cfeatures:mfeatures;
                    
                    //make a call to insert the features
                   // const endpointforSplUserURL = aiDcapRegister(registerObj);
                    //insert call started
                    let insertUserFeaturesendpoint = insertUserFeaturesByIdEndPoint(email,role);// adv_insertFeaturesById(selectUserId,JSON.stringify(selectedFeatures));
        
                    let body = {
                        "selectedFeatures":roleFeatures
                        };
                        console.log("body",body);
                       toast.success("saving user settings!", { position: toast.POSITION.TOP_CENTER });   
                  
                   axios( insertUserFeaturesendpoint , { method: "POST" , data: body, headers}).
                    then((resp) => {
                      if (resp.status === 200 || resp.status === 201) {        
                          toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
                         // window.location.reload();
                         props.history.push("/create-model");
                      }
                    });
                  
                    //insert call ending
                    
                   
                    
                }
                else
                {
                    props.history.push("/create-model");
                }
                 //check for Chep User call end
                
                
               // props.history.push("/create-model");
            }
            else
            {
                toast.error(`error on User registration.`, { position: toast.POSITION.TOP_CENTER });
            }
        }).catch((err) => {
            toast.error(`Some thing went wrong.`, { position: toast.POSITION.TOP_CENTER });
        });
    }
    const registerView = () => {
        if (loader == false) {
            return (
                <div className="register-box">
                    <div className="text-center">
                    <h5> Add User</h5>
                        {/* <a className="navbar-brand" href="#">
                            <img src={logo} className="img-fluid logo" />
                        </a>
                        <br /> <br /> */}
                    </div>
                    {/* <div>
                        <h5> Add User</h5>
                        <hr />
                    </div> */}
                    <div className="row flex-column align-items-center">
                        <div className="col-md-6">
                            <label>First Name</label>
                            <input type="text" placeholder="First Name" value={firstName} onChange={handleChangeName} className="form-control" name="username"></input>
                        </div>
                        <div className="col-md-6">
                            <label>Last Name</label>
                            <input type="text" placeholder="Last Name" value={lastName} onChange={handleChangeLastName} className="form-control" name="username"></input>
                        </div>
                        <div className="col-md-6">
                            <label>Email</label>
                            <input type="text" placeholder="Email" value={email} onChange={handleChangeEmail} className="form-control" name="username"></input>
                        </div>
                        <div className="col-md-6">
                            <label>Contact No </label>
                            <input type="text" placeholder="Contact Number" value={contact} onChange={handleChangeContact} className="form-control" name="username"></input>
                        </div>

                        <div className="col-md-6">
                            <label>Role </label>
                            {dropDownSelectionView()}
                        </div>

                        <div className="col-md-6">
                            <label>Tenent Name</label>
                            <div>
                                <Select options={tenantNames}
                                    onChange={handleSelectTenant}
                                    value={tenentValue}
                                    placeholder="Select"
                                    className="react-select-container zindex-20"
                                    // isClearable={true}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#161a1f",
                                            primary: "#6b727d",
                                            neutral0: "#222830",
                                            neutral20: "#44474c",
                                            neutral30: "#272c33",
                                            neutral50: "#fff",
                                            neutral80: "#9da7b5",
                                        },
                                    })}

                                />
                            </div>
                        </div>
                        {/* <div className="col-md-4">
                            <label>CHEP Role</label>
                            <div>
                                <Select options={chepUserOptions}
                                    onChange={handleSelectCHEPRole}
                                    value={chepRoleValue}
                                    placeholder="Select"
                                    className="react-select-container zindex-20"
                                    // isClearable={true}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#161a1f",
                                            primary: "#6b727d",
                                            neutral0: "#222830",
                                            neutral20: "#44474c",
                                            neutral30: "#272c33",
                                            neutral50: "#fff",
                                            neutral80: "#9da7b5",
                                        },
                                    })}

                                />
                            </div>
                        </div> */}
                    </div>
                    <div className="row mt-4 justify-content-center">
                        <div className="">
                            <button className="btn" onClick={() => validation()} > Submit </button>
                        </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {/* <div className="mr-2">
                            <button className="btn" onClick={() => history.goBack()} >Cancel</button>
                        </div> */}
                    </div>

                </div>
            )
        } else {
            return (
                <div>
                    <Spinner
                        label="Loading ..."
                        ariaLive="off"
                        className="loading" size={SpinnerSize.large} />
                </div>
            )
        }

    }

    return (
        <>
            <HeaderComponent
                history={props.history}
                match={props.match}
                location={props.location} />
            <div className="container">
                <div className="row mt-4  justify-content-center">
                    <div className="col-md-8">
                        {registerView()}
                    </div>
                </div>

            </div>
        </>

    );
};

export default Register;
